"use strict";

const WqMonitoringConstants = function () {
  const dryWeatherScreeningInspectionTypes = ["idde-screening", "idde-rescreen"];

  var isDryWeatherScreeningType = function (inspectionType) {
    return dryWeatherScreeningInspectionTypes.includes(inspectionType);
  };

  var getWqInspectionTypeOptions = function () {
    return ToolSettings.getDomainOptions("wq_inspection_type");
  };

  var getFlowConditionOptions = function () {
    return ToolSettings.getDomainOptions("flow_condition");
  };

  var getFilterFlowConditionOptions = function () {
    const options = getFlowConditionOptions();
    return [...options, { name: "No Data", value: "null" }];
  };

  var getPrecipitationTypeOptions = function () {
    return FormSettings.getDropdownOptions("precipitation-type", { tool: "muni" });
  };

  var getCurrentWeatherOptions = function () {
    return ToolSettings.getDomainOptions("current_weather");
  };

  var getDefaultInspectionTypeByTool = function (
    reScreeningNeeded = false,
    forcedInspectionType = null,
  ) {
    const tool = Tree.get("tool");

    if (tool === "outmon") {
      return "wq-monitoring";
    } else if (tool === "idde") {
      return forcedInspectionType ?? (reScreeningNeeded ? "idde-rescreen" : "idde-screening");
    } else {
      return "routine-inspection";
    }
  };

  var isWqMonitoringWorkflowAssetType = function (assetType) {
    return ["outfall", "sampling-site"].includes(assetType);
  };

  return {
    getWqInspectionTypeOptions,
    getFlowConditionOptions,
    getFilterFlowConditionOptions,
    getPrecipitationTypeOptions,
    getCurrentWeatherOptions,
    getDefaultInspectionTypeByTool,
    isWqMonitoringWorkflowAssetType,
    isDryWeatherScreeningType,
  };
};

module.exports = WqMonitoringConstants();

const FormSettings = require("../../settings/formSettings");
const ToolSettings = require("../../settings/toolSettings");
const Tree = require("../../tree");
